import { render, staticRenderFns } from "./currency.vue?vue&type=template&id=d2c5caea&scoped=true&lang=pug&"
import script from "./currency.vue?vue&type=script&lang=js&"
export * from "./currency.vue?vue&type=script&lang=js&"
import style0 from "./currency.vue?vue&type=style&index=0&id=d2c5caea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2c5caea",
  null
  
)

export default component.exports